import { ArrowRight, Phone, MapPin } from "lucide-react";
import { PHONE, PHONE_TEL, LOCATION, AREA } from "@/lib/site-data";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center asphalt-bg overflow-hidden pt-28 pb-16"
    >
      {/* Decorative orange bars */}
      <div className="absolute top-24 right-0 h-[2px] w-1/3 bg-bgtp-orange/40 hidden md:block" />
      <div className="absolute bottom-16 left-0 h-[2px] w-1/4 bg-bgtp-silver/30 hidden md:block" />

      <div className="max-w-7xl mx-auto w-full px-5 md:px-8 grid lg:grid-cols-12 gap-10 items-center relative">
        <div className="lg:col-span-8">
          <div className="eyebrow mb-6" data-testid="hero-eyebrow">BGTP — Saint-Didier-sur-Chalaronne</div>

          <h1 className="font-heading text-[64px] leading-[0.85] sm:text-7xl md:text-8xl lg:text-[140px] tracking-tight uppercase text-white">
            <span className="block">Du <span className="silver-text">terrassement</span></span>
            <span className="block">à la <span className="brush-highlight"><span className="relative z-10 text-white">rénovation</span></span>,</span>
            <span className="block text-bgtp-steel/90 text-[40px] sm:text-5xl md:text-6xl lg:text-7xl">on s'occupe de tout.</span>
          </h1>

          <p className="mt-8 max-w-2xl text-white/75 text-base sm:text-lg leading-relaxed">
            Terrassement, creusement de tranchées, création de cour, aménagement extérieur
            et tous types de rénovation. Une équipe locale, du sérieux et un devis gratuit
            sous 48h dans l'{AREA}.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-devis"
              onClick={() => scrollTo("contact")}
              className="btn-primary"
            >
              Devis gratuit <ArrowRight className="w-5 h-5" />
            </button>
            <a
              data-testid="hero-cta-call"
              href={`tel:${PHONE_TEL}`}
              className="btn-ghost"
            >
              <Phone className="w-5 h-5" /> {PHONE}
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.22em] text-bgtp-steel">
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-bgtp-orange" /> {LOCATION}</div>
            <div className="hidden sm:block w-px h-4 bg-bgtp-line" />
            <div>Particuliers & Professionnels</div>
            <div className="hidden sm:block w-px h-4 bg-bgtp-line" />
            <div>Devis sous 48h</div>
          </div>
        </div>

        {/* Right column: industrial spec card — hidden on mobile */}
        <div className="hidden lg:block lg:col-span-4">
          <div className="relative">
            <div className="absolute -inset-2 border border-bgtp-orange/40 pointer-events-none" />
            <div className="industrial-card bg-bgtp-ink/80 backdrop-blur-sm">
              <div className="font-heading text-3xl uppercase tracking-wider mb-6">Travaux récents</div>
              <ul className="space-y-3 text-sm">
                {[
                  ["Cour gravillonnée", "120 m²"],
                  ["Tranchée réseau", "45 ml"],
                  ["Allée + bordures", "28 ml"],
                  ["Rénovation pièce", "Complète"],
                ].map(([k, v]) => (
                  <li key={k} className="flex items-center justify-between border-b border-bgtp-line pb-2">
                    <span className="text-white/80">{k}</span>
                    <span className="font-heading text-bgtp-orange text-lg tracking-wider">{v}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6 divider-orange" />
              <div className="mt-5 text-xs text-bgtp-steel">
                Intervention selon chantier · Déplacement 01 & environs
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
